import { combineReducers, configureStore } from "@reduxjs/toolkit";
// reducers
import auth from "./auth/reducer";
import toast from "./toast/reducer";
var reducer = combineReducers({
    auth: auth,
    toast: toast,
});
var rootReducer = function (state, action) {
    // logout case where we want to reset all state from redux
    if (action.type === "RESET")
        state = undefined;
    return reducer(state, action);
};
var setupStore = function () {
    return configureStore({
        reducer: rootReducer,
        devTools: { trace: true },
        // preloadedState,
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware({
                serializableCheck: {
                    /*
                      Reference
                      * https://redux-toolkit.js.org/api/serializabilityMiddleware
                      * https://redux-toolkit.js.org/api/immutabilityMiddleware
          
                      These ignored actions and paths help avoid console warnings, because the actions or
                      paths are not serializable, for example when we save moment times in the redux store
                    */
                    ignoredActions: [],
                    ignoredPaths: [],
                },
            });
        },
    });
};
var store = setupStore();
export default store;
